import React, { useCallback, useEffect, useState } from "react";
import * as Mui from "@mui/material";
import { showToast } from "services/utils/Status";
import { customGetAPIWithToken } from "services/utils/CustomAPI";
import { userManagementError } from "services/constants/ErrorMessages";
import LoginLogo from "../../../assets/img/brand/organflow 2.0 logo.png";
import SelectDomainImg from "../../../assets/img/brand/SelectDomain.png";
import { Loader } from "components/Loader";
import SearchIcon from "@mui/icons-material/Search";
import { getAccessBasedRoute } from "services/utils/accessedBasedRoute";
import { supportLabel, adminRoleName } from "services/constants";
import { setCompanyList } from "../../../services/Redux/userToken";

const keys = ["domain_name", "firm_name"];

export const TenantDetails = ({
  setIsLoading,
  groupButtonActiveTap,
  tenantDetails,
  setShowTenantDetails,
}) => {
  const [width, setWidth] = useState(window.innerWidth);
  const [searchTenatDetails, setSearchTenatDetails] = useState([]);
  const [globalSearchValue, setGlobalSearchValue] = useState("");

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const navigateToDomain = (row) => {
    let domainUrl = "";
    let domain = "";
    if (row.domain_name === "localhost" || row.domain_name === "127.0.0.1") {
      domainUrl = `http://${row.domain_name}:8000/api/`;
      domain = `http://${row.domain_name}:3000`;
    } else {
      domainUrl = `https://${row.domain_name}/api/`;
      domain = `https://${row.domain_name}`;
    }
    localStorage.clear();
    onSubmit(row, domainUrl, domain);
  };

  const getProductAccess = useCallback(async (token, userId, domainUrl) => {
    try {
      const response = await fetch(
        `${domainUrl}login/available/products/?user_id=${userId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${token}`,
          },
        },
      );
      const res_data = await response.json();
      if (response.ok) {
        localStorage.setItem("productAccess", JSON.stringify(res_data));
      } else {
        throw new Error(res_data.error);
      }
    } catch (error) {
      showToast(error.message);
    }
  }, []);

  const getCompanyDetails = useCallback(
    async (token, domainUrl, domain, data, type) => {
      try {
        const response = await fetch(`${domainUrl}company/`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${token}`,
          },
        });
        const resData = await response.json();
        const urlpath = reDirectPath(resData, type);
        if (response.ok) {
          if (resData.length === 0) {
            let url =
              groupButtonActiveTap === "Email"
                ? `${domain}${urlpath}?token=${encodeURIComponent(
                    token,
                  )}&email=${data.email.toLowerCase()}`
                : `${domain}${urlpath}?token=${encodeURIComponent(
                    token,
                  )}&ph_no=${data.phonenumber}`;
            window.location.href = url;
          } else {
            localStorage.setItem("currentScreen", "My Zone");
            localStorage.setItem("currentSubMenu", "Calendar");
            let url =
              groupButtonActiveTap === "Email"
                ? `${domain}${urlpath}?token=${encodeURIComponent(
                    token,
                  )}&email=${data.email.toLowerCase()}`
                : `${domain}${urlpath}?token=${encodeURIComponent(
                    token,
                  )}&ph_no=${data.phonenumber}`;
            window.location.href = url;
          }
        } else {
          throw new Error(resData.error);
        }
      } catch (error) {
        showToast(error.message);
      }
    },
    [groupButtonActiveTap],
  );

  const getCurrentUserAccessibleCompany = useCallback(
    async (token, userId, domainUrl) => {
      const companyAccess = await customGetAPIWithToken(
        `${domainUrl}user-group/user/company/?user_id=${userId}`,
        token,
      );
      if (companyAccess.ok) {
        setCompanyList(JSON.stringify(companyAccess.responseDetails));
        localStorage.setItem(
          "companyAccess",
          JSON.stringify(companyAccess.responseDetails),
        );
        localStorage.setItem(
          "topbarCompanyId",
          companyAccess.responseDetails?.length !== 0
            ? companyAccess?.responseDetails[0]?.company_id
            : 99999,
        );
        localStorage.setItem(
          "topbarCompanyName",
          companyAccess.responseDetails?.length !== 0
            ? companyAccess?.responseDetails[0]?.company_name
            : "All Companies",
        );
      }
    },
    [],
  );

  const onSubmit = useCallback(
    async (data, domainUrl, domain) => {
      let url =
        groupButtonActiveTap === "Email"
          ? `${domainUrl}login/email_verfication/?email=${data.email.toLowerCase()}`
          : `${domainUrl}phone_verfication/?phone_no=${data.phonenumber}`;
      const emailResponse = await fetch(url, {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      });
      const emailReturnResponse = await emailResponse.json();
      if (
        emailResponse.status === 200 &&
        emailReturnResponse.user_status === "Active"
      ) {
        localStorage.clear();
        function getCSRFToken() {
          return document.cookie
            .split("; ")
            .find((row) => row.startsWith("csrftoken="))
            ?.split("=")[1];
        }

        const isLocalhost =
          window.location.hostname === "localhost" ||
          window.location.hostname.startsWith("127.");

        let userResponse;
        const userId = emailReturnResponse.user_id;

        if (!isLocalhost) {
          await fetch(`${domainUrl}csrf/`, { credentials: "include" });

          userResponse = await fetch(`${domainUrl}custom-token-auth/`, {
            method: "POST",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
              "X-CSRFToken": getCSRFToken(),
            },
            body: JSON.stringify({
              username: emailReturnResponse.emailuser.username,
              password: data.tenant_password,
            }),
          });
        } else {
          userResponse = await fetch(`${domainUrl}custom-token-auth/`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              username: emailReturnResponse.emailuser.username,
              password: data.tenant_password,
            }),
          });
        }
        const userReturnResponse = await userResponse.json();
        if (userReturnResponse?.error) {
          showToast("error", userReturnResponse?.error);
        }
        if (userResponse.status === 200) {
          const userData = {
            id: userId,
            first_name: emailReturnResponse.emailuser.first_name,
            username: emailReturnResponse.emailuser.username,
            last_name: emailReturnResponse.emailuser.last_name,
            email: emailReturnResponse.emailuser.email,
            type: emailReturnResponse.type,
            phonenumber: emailReturnResponse.type.phonenumber,
            approver: emailReturnResponse.approver,
            teamlead: emailReturnResponse.teamlead,
            firmName: emailReturnResponse.firm_name,
            approver_id: emailReturnResponse.approver_id,
            image_url: emailReturnResponse.image_url,
            department_id: emailReturnResponse.department_id,
            department_name: emailReturnResponse.department_name,
            employee_id: emailReturnResponse.employee_id,
            designation: emailReturnResponse.designation,
          };
          await getCurrentUserAccessibleCompany(
            userReturnResponse.token,
            userId,
            domainUrl,
          );
          await getProductAccess(userReturnResponse.token, userId, domainUrl);
          localStorage.setItem("currentuser", JSON.stringify(userData));
          localStorage.setItem("token", userReturnResponse.token);
          localStorage.setItem(
            "sessionToken",
            userReturnResponse.session_token,
          );

          getCompanyDetails(
            userReturnResponse.token,
            domainUrl,
            domain,
            data,
            emailReturnResponse.type,
          );
        }
      } else if (
        emailReturnResponse.exists === false ||
        emailResponse.status === 400
      ) {
        showToast("error", emailReturnResponse.error);
        setShowTenantDetails(false);
        setIsLoading(false);
      } else if (emailReturnResponse.user_status === "Inactive") {
        showToast("error", userManagementError.emailReturnResponseError);
        setShowTenantDetails(false);
        setIsLoading(false);
      }
    },
    [
      getCompanyDetails,
      getCurrentUserAccessibleCompany,
      getProductAccess,
      groupButtonActiveTap,
      setIsLoading,
      setShowTenantDetails,
    ],
  );

  const reDirectPath = (companyData, type) => {
    let accessibleProducts = JSON.parse(localStorage.getItem("productAccess"));
    let product_name = accessibleProducts
      ? type === supportLabel
        ? supportLabel
        : type === adminRoleName && companyData?.length === 0
          ? "Administration"
          : accessibleProducts[0]?.product_name
      : "default";
    const accesbasedReroutePath = getAccessBasedRoute(product_name);
    return accesbasedReroutePath;
  };

  useEffect(() => {
    if (tenantDetails.length === 1) {
      let row = tenantDetails[0];
      let domainUrl = "";
      let domain = "";
      if (row.domain_name === "localhost" || row.domain_name === "127.0.0.1") {
        domainUrl = `http://${row.domain_name}:8000/api/`;
        domain = `http://${row.domain_name}:3000`;
      } else {
        domainUrl = `https://${row.domain_name}/api/`;
        domain = `https://${row.domain_name}`;
      }
      onSubmit(row, domainUrl, domain);
    }
  }, [onSubmit, tenantDetails]);

  useEffect(() => {
    if (tenantDetails?.length !== 0 || tenantDetails?.length === 0) {
      const filteredResults = tenantDetails?.filter((item) =>
        keys.some((key) =>
          item[key]
            ?.toString()
            .toLowerCase()
            .includes(globalSearchValue.toString().toLowerCase()),
        ),
      );
      setSearchTenatDetails(filteredResults);
    }
  }, [globalSearchValue, tenantDetails]);

  return tenantDetails.length === 1 ? (
    <Loader info="Loading..." />
  ) : (
    <React.Fragment>
      <Mui.Grid
        container
        style={{
          overflowY: "hidden",
          height: "100vh",
          justifyContent: "center",
        }}
      >
        <Mui.Grid item xs={0} sm={0} md={6} lg={6}>
          <Mui.Paper style={{ height: "100%" }}>
            <Mui.Box
              component="img"
              src={SelectDomainImg}
              alt="Login"
              sx={{
                width: "100%",
                height: { xs: "0px", sm: "0px", md: "100%", lg: "100%" },
                objectFit: "cover",
              }}
            />
            <a href="https://stringconsultants.com/">
              <Mui.Box
                sx={{
                  position: "absolute",
                  left: "25%",
                  bottom: "0.2%",
                  transform: "translate(-50%, -50%)",
                  color: "white",
                  fontSize: "12px",
                  textAlign: "center",
                }}
              >
                © 2024 String Consultants. All Rights Reserved
              </Mui.Box>
            </a>
          </Mui.Paper>
        </Mui.Grid>
        <Mui.Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          sx={{ padding: { xs: 1, sm: 1, md: 1, lg: 1 } }}
        >
          <Mui.Paper style={{ height: "100%" }}>
            <Mui.Grid
              container
              justifyContent="flex-end"
              sx={{ paddingTop: 2, paddingRight: 2, paddingBottom: 2 }}
            >
              <img
                src={LoginLogo}
                alt="LoginLogo"
                style={{ height: "22%", width: "22%" }}
              />
            </Mui.Grid>
            <Mui.Grid container sx={{ paddingLeft: 2.8 }}>
              <Mui.Card
                component="form"
                sx={{
                  p: "6px 6px",
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  borderRadius: 2,
                  boxShadow: 2,
                }}
              >
                <Mui.IconButton type="button" aria-label="search">
                  <SearchIcon />
                </Mui.IconButton>
                <Mui.InputBase
                  sx={{ ml: 1, flex: 1 }}
                  placeholder="Search for your desired domain..."
                  inputProps={{ "aria-label": "search google maps" }}
                  value={globalSearchValue}
                  onChange={(e) => setGlobalSearchValue(e.target.value)}
                />
              </Mui.Card>
            </Mui.Grid>

            {/* </form> */}
            <Mui.Box
              sx={{
                overflowY: "auto",
                overflowX: "hidden",
                display: "flex",
                flexDirection: "column",
                paddingX: 2,
                height: { xs: "75vh", sm: "75vh", md: "75vh", lg: "80vh" },
                position: "relative",
                width: "100%",
                mt: 1,
              }}
            >
              <Mui.Stack pacing={2} sx={{ width: "100%" }}>
                {searchTenatDetails?.length === 0 ? (
                  <Mui.TableRow sx={{ paddingTop: 2, paddingLeft: 2 }}>
                    <Mui.Alert severity="info">No data available</Mui.Alert>
                  </Mui.TableRow>
                ) : (
                  searchTenatDetails.map((row, index) => (
                    <Mui.Grid container sx={{ padding: 1 }}>
                      <Mui.Card
                        onClick={() => navigateToDomain(row)}
                        sx={{
                          minWidth: {
                            xs: parseInt(width) / 1.1,
                            sm: parseInt(width) / 1.1,
                            md: parseInt(width) / 2.1,
                            lg: parseInt(width) / 2.1,
                            xl: parseInt(width) / 2.1,
                          },
                          cursor: "pointer",
                          borderRadius: 2,
                          boxShadow: 3,
                        }}
                        fullWidth
                      >
                        <Mui.CardContent>
                          <Mui.Typography
                            variant="h6"
                            sx={{ fontWeight: "bold" }}
                          >
                            {row.firm_name}
                          </Mui.Typography>
                          <Mui.Typography
                            variant="body1"
                            color="text.secondary"
                          >
                            {row.domain_name}
                          </Mui.Typography>
                        </Mui.CardContent>
                      </Mui.Card>
                    </Mui.Grid>
                  ))
                )}
              </Mui.Stack>
            </Mui.Box>
          </Mui.Paper>
        </Mui.Grid>
      </Mui.Grid>
    </React.Fragment>
  );
};
